// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.18.1';
//# sourceMappingURL=version.js.map